import React from "react";
import { classNames } from "../../../helpers/classNames";
import Button from "../../form/Button";

const ReturnPolicy = ({ className, data = {} }) => {
  return (
    <div
      className={classNames(
        "rounded-xl border border-slate-300 py-10 px-6 bg-white space-y-4",
        className
      )}
    >
      <div className="flex items-start gap-4 mb-4 text-deep-purple">
        <i className="fa-solid fa-shield-check text-2xl"></i>
        <div className="flex-1">
          <h3 className={"text-2xl font-bold text-foreground mb-4"}>
            {(data?.daysBeforeRefund || 0) > 0
              ? data?.daysBeforeRefund || 0
              : "Same"}{" "}
            Day Return Policy
          </h3>
          {/* <p className={"text-muted-foreground mb-4"}>{data?.description}</p> */}
        </div>
      </div>

      <ul className="space-y-2 mb-6">
        <li className="flex items-center gap-2">
          <i className="fa-light fa-circle-check"></i>
          <span className={"text-muted-foreground mb-4".replace("mb-4", "")}>
            No questions asked
          </span>
        </li>
        <li className="flex items-center gap-2">
          <i className="fa-light fa-circle-check"></i>
          <span className={"text-muted-foreground mb-4".replace("mb-4", "")}>
            Full refund guarantee
          </span>
        </li>
        <li className="flex items-center gap-2">
          <i className="fa-light fa-circle-check"></i>
          <span className={"text-muted-foreground mb-4".replace("mb-4", "")}>
            Full refund on original payment method
          </span>
        </li>
        <li className="flex items-center gap-2">
          <i className="fa-light fa-circle-check"></i>
          <span className={"text-muted-foreground mb-4".replace("mb-4", "")}>
            Instant refunds
          </span>
        </li>
      </ul>

      {/* <div className="flex items-center gap-4">
        <Button
          buttonLabelClasses="text-white uppercase text-lg font-bold"
          buttonClasses="w-full  rounded-lg h-14"
          buttonLabel={"Contact Support"}
        />
      </div> */}
    </div>
  );
};

export default ReturnPolicy;
